import React from 'react';
import { Box, Icon } from 'pounceV2';
import { useListAvailableLogProviders } from 'Pages/Configure/LogSources/LogSourceOnboarding/ListAvailableLogProviders/graphql/listAvailableLogProviders.generated';
import AvailableLogProviderLogoV3 from 'Pages/Configure/components/AvailableLogProviderLogo/AvailableLogProviderLogoV3';

const LogProviderIconByLogType = ({ logType }: { logType?: string }) => {
  const { loading: logProviderLoading, data: logProviderData } = useListAvailableLogProviders();

  // searches for the log provider that includes the log type. The provider id can be used to display the proper logo
  const logo = React.useMemo(() => {
    const source = logProviderData?.listAvailableLogProviders?.results.find(
      provider => !!provider.availableParsers.find(parser => parser.name === logType),
    );
    return source?.id;
  }, [logProviderData?.listAvailableLogProviders?.results, logType]);
  return logType && !logProviderLoading && logo ? (
    <Box p={1} display="flex" data-testid={logType}>
      <AvailableLogProviderLogoV3 id={logo} alt={logType} size={24} />
    </Box>
  ) : (
    <Icon data-testid="default-icon" size="large" type="detection" display="block" />
  );
};

export default LogProviderIconByLogType;
